import { GetEndpointResponse, useApiQuery } from '@water-web/api';

import { UserService } from '@app/apiServices';

export const useUser = (): GetEndpointResponse<typeof UserService.current> => {
  return useApiQuery({ endpoint: UserService.current }).data;
};
